import React from 'react';
import {
  Typography,
  MenuItem,
  Link,
  Icon,
  Divider
} from '@mui/material';

import PropTypes, { InferProps } from 'prop-types';

/***
 * @function ButtonLinkMenu
 * @description Button Menu
 * @param {string} strName - Text to display.
 * @param {string} strUrl - Section or URL to direct to. The URL starts with https://
 * @param {?Element} elementIcon - Optional, icon to display.
 * @param {?Boolean} divider - Optional, add a divider above the button.
 * @param {?function} fncClose - Optional, run a function in addition to the redirect.
 *
 * @example
 * <ButtonLinkMenu strName="Help" strUrl="/help" elementIcon={<SettingsIcon  sx={{ fontSize:16 }} />} divider={true|false} fncClose={functión} />
 * <ButtonLinkMenu strName="Help" strUrl="/help" elementIcon={<SettingsIcon  sx={{ fontSize:16 }} />} divider={true|false} />
 * <ButtonLinkMenu strName="Help" strUrl="/help" elementIcon={<SettingsIcon  sx={{ fontSize:16 }} />} />
 * <ButtonLinkMenu strName="Help" strUrl="/help" />
 *
 */
function ButtonLinkMenu ({ strName, strUrl, elementIcon, divider, fncClose }: InferProps<typeof ButtonLinkMenu.propTypes>) {
  const lstStyle = {
    icon: {
      margin: 0,
      padding: 0,
      marginRight: '0.5rem'
    },
    iconEmpty: {
      marginRight: '0.5rem'
    }
  }

  return (
    <>
      { divider && <Divider sx={{ width: '75%', mx: 'auto' }} /> }
      {
        (fncClose != null)
        ? (
          <MenuItem key={strName}
            onClick={ () => { fncClose(); } }
          >
            <Link href={strUrl} underline="none" target={(strUrl.toLocaleLowerCase().startsWith('https://') || strUrl.toLocaleLowerCase().startsWith('http://')) ? '_blank' : ''} rel="noopener" >
              <Typography textAlign="center" >
                { (elementIcon != null) ? <Icon style={lstStyle.icon} >{elementIcon}</Icon> : <Icon style={lstStyle.iconEmpty} ></Icon> }
                {strName}
              </Typography>
            </Link>
          </MenuItem>
          )
        : (
          <MenuItem key={strName} >
            <Link href={strUrl} underline="none" target={(strUrl.toLocaleLowerCase().startsWith('https://') || strUrl.toLocaleLowerCase().startsWith('http://')) ? '_blank' : ''} rel="noopener" >
              <Typography textAlign="center" >
                { (elementIcon != null) ? <Icon style={lstStyle.icon} >{elementIcon}</Icon> : <Icon style={lstStyle.iconEmpty} ></Icon> }
                {strName}
              </Typography>
            </Link>
          </MenuItem>
          )
      }
    </>
  )
}

ButtonLinkMenu.propTypes = {
  strName: PropTypes.string.isRequired,
  strUrl: PropTypes.string.isRequired,
  elementIcon: PropTypes.element,
  divider: PropTypes.bool,
  fncClose: PropTypes.func
}

export default ButtonLinkMenu
